import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "row"
}
const _hoisted_2 = { class: "col-12 col-lg-8 col-xxl-6 mb-4" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "mb-0" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "card-footer text-center" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 2,
  class: "row"
}
const _hoisted_10 = {
  key: 0,
  class: "col-12 col-lg-8 col-xxl-6 mb-4"
}
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = { class: "mb-0" }
const _hoisted_14 = { class: "card-footer text-center" }
const _hoisted_15 = ["href"]
const _hoisted_16 = {
  key: 0,
  class: "col-12 col-lg-6 col-xxl-4 d-flex flex-column justify-content-between"
}
const _hoisted_17 = { class: "mb-4" }
const _hoisted_18 = { class: "mb-4" }
const _hoisted_19 = {
  key: 1,
  class: "col-12 col-lg-6 col-xxl-4 d-flex flex-row mb-4"
}
const _hoisted_20 = {
  key: 2,
  class: "col-12 col-lg-6 col-xxl-4 d-flex flex-row mb-4"
}
const _hoisted_21 = {
  key: 3,
  class: "col-12 col-lg-6 col-xxl-4 d-flex flex-row mb-4"
}
const _hoisted_22 = {
  key: 4,
  class: "col-12 col-lg-6 col-xxl-4 d-flex flex-row mb-4"
}
const _hoisted_23 = {
  key: 5,
  class: "col-12 col-lg-6 col-xxl-4 d-flex flex-row mb-4"
}
const _hoisted_24 = {
  key: 6,
  class: "col-12 col-lg-6 col-xxl-4 d-flex flex-row mb-4"
}
const _hoisted_25 = { class: "col-12 col-lg-6 col-xxl-4 d-flex flex-row mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_subscriptions_skeleton = _resolveComponent("subscriptions-skeleton")!
  const _component_status_card = _resolveComponent("status-card")!
  const _component_gtr_basic_to_lite = _resolveComponent("gtr-basic-to-lite")!
  const _component_gtr_vip_to_lite = _resolveComponent("gtr-vip-to-lite")!
  const _component_gtr_basic = _resolveComponent("gtr-basic")!
  const _component_gtr_win = _resolveComponent("gtr-win")!
  const _component_gtr_fly = _resolveComponent("gtr-fly")!
  const _component_gtr_go = _resolveComponent("gtr-go")!
  const _component_mmi_colombia = _resolveComponent("mmi-colombia")!
  const _component_checkout_modal = _resolveComponent("checkout-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.getUserPackageStatus === 'cargando')
      ? (_openBlock(), _createBlock(_component_subscriptions_skeleton, { key: 0 }))
      : (_ctx.getUserPackageStatus === 'error')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "card-header" }, [
                  _createElementVNode("i", { class: "fas fa-triangle-exclamation me-2" }),
                  _createTextVNode("No pudimos cargar tus suscripciones ")
                ], -1)),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("p", _hoisted_5, [
                    _cache[1] || (_cache[1] = _createTextVNode(" No hemos podido comprobar qué tienes contratado, así que preferimos no enseñarte nada antes que enseñarte algo equivocado. Vuelve a intentarlo; si sigue igual, escríbenos a ", -1)),
                    _createElementVNode("a", {
                      href: 'mailto:' + _ctx.supportEmail
                    }, _toDisplayString(_ctx.supportEmail), 9, _hoisted_6),
                    _cache[2] || (_cache[2] = _createTextVNode(". ", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-secondary",
                    disabled: _ctx.isRetrying,
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.retryPackageStatus && _ctx.retryPackageStatus(...args)))
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fas me-2", _ctx.isRetrying ? 'fa-spinner fa-spin' : 'fa-rotate-right'])
                    }, null, 2),
                    _cache[3] || (_cache[3] = _createTextVNode("Reintentar ", -1))
                  ], 8, _hoisted_8)
                ])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_ctx.isDormantUnplacedSelf)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[6] || (_cache[6] = _createElementVNode("h5", { class: "card-header" }, [
                      _createElementVNode("i", { class: "fas fa-info-circle me-2" }),
                      _createTextVNode("Reactivación de tu cuenta ")
                    ], -1)),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.dormantSelfMessage), 1)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("a", {
                        href: 'mailto:' + _ctx.supportEmail,
                        class: "btn btn-secondary lh-sm"
                      }, [
                        _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fas fa-envelope me-2" }, null, -1)),
                        _createTextVNode(_toDisplayString(_ctx.supportEmail), 1)
                      ], 8, _hoisted_15)
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.getUserCurrentPackage !== 'none')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_status_card, {
                            "card-type": "package",
                            "subscription-id": _ctx.academySubscriptionId,
                            "package-id": _ctx.getUserCurrentPackage,
                            lastQuote: _ctx.quote,
                            isQuoting: _ctx.isQuoting,
                            onClearQuote: _ctx.clearQuote,
                            onRequestQuote: _ctx.createQuote
                          }, null, 8, ["subscription-id", "package-id", "lastQuote", "isQuoting", "onClearQuote", "onRequestQuote"])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_status_card, {
                            "card-type": "license",
                            "subscription-id": _ctx.licenseSubscriptionId,
                            "package-id": _ctx.getUserCurrentPackage,
                            lastQuote: _ctx.quote,
                            isQuoting: _ctx.isQuoting,
                            onClearQuote: _ctx.clearQuote,
                            onRequestQuote: _ctx.createQuote
                          }, null, 8, ["subscription-id", "package-id", "lastQuote", "isQuoting", "onClearQuote", "onRequestQuote"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isLevelFly && _ctx.isUserActive === false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createVNode(_component_gtr_basic_to_lite, {
                          "subscription-id": "gtr-go",
                          lastQuote: _ctx.quote,
                          isQuoting: _ctx.isQuoting,
                          onClearQuote: _ctx.clearQuote,
                          onRequestQuote: _ctx.createQuote
                        }, null, 8, ["lastQuote", "isQuoting", "onClearQuote", "onRequestQuote"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isLevelWin && _ctx.isUserActive === false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createVNode(_component_gtr_vip_to_lite, {
                          "subscription-id": "gtr-go",
                          lastQuote: _ctx.quote,
                          isQuoting: _ctx.isQuoting,
                          onClearQuote: _ctx.clearQuote,
                          onRequestQuote: _ctx.createQuote
                        }, null, 8, ["lastQuote", "isQuoting", "onClearQuote", "onRequestQuote"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isLevelGo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createVNode(_component_gtr_basic, {
                          "subscription-name": "GTR Fly",
                          "subscription-id": "gtr-fly",
                          "promotion-type": "upgrade",
                          "promotion-id": "go-to-fly-upgrade",
                          lastQuote: _ctx.quote,
                          isQuoting: _ctx.isQuoting,
                          onClearQuote: _ctx.clearQuote,
                          onRequestQuote: _ctx.createQuote
                        }, null, 8, ["lastQuote", "isQuoting", "onClearQuote", "onRequestQuote"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.getUserCurrentPackage === 'none')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createVNode(_component_gtr_win, {
                          "subscription-id": "gtr-win",
                          lastQuote: _ctx.quote,
                          isQuoting: _ctx.isQuoting,
                          onClearQuote: _ctx.clearQuote,
                          onRequestQuote: _ctx.createQuote
                        }, null, 8, ["lastQuote", "isQuoting", "onClearQuote", "onRequestQuote"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.getUserCurrentPackage === 'none')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createVNode(_component_gtr_fly, {
                          "subscription-id": "gtr-fly",
                          "subscription-name": "GTR Fly",
                          lastQuote: _ctx.quote,
                          isQuoting: _ctx.isQuoting,
                          onClearQuote: _ctx.clearQuote,
                          onRequestQuote: _ctx.createQuote
                        }, null, 8, ["lastQuote", "isQuoting", "onClearQuote", "onRequestQuote"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.getUserCurrentPackage === 'none')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createVNode(_component_gtr_go, {
                          "subscription-id": "gtr-go",
                          lastQuote: _ctx.quote,
                          isQuoting: _ctx.isQuoting,
                          onClearQuote: _ctx.clearQuote,
                          onRequestQuote: _ctx.createQuote
                        }, null, 8, ["lastQuote", "isQuoting", "onClearQuote", "onRequestQuote"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_mmi_colombia, {
                      "subscription-name": "Acelerador de<br \\>Riqueza",
                      "subscription-id": "mmi-colombia",
                      lastQuote: _ctx.quote,
                      isQuoting: _ctx.isQuoting,
                      onClearQuote: _ctx.clearQuote,
                      onRequestQuote: _ctx.createQuote
                    }, null, 8, ["lastQuote", "isQuoting", "onClearQuote", "onRequestQuote"])
                  ])
                ], 64))
          ])),
    _createVNode(_component_checkout_modal, {
      quote: _ctx.quote,
      onClearQuote: _ctx.clearQuote,
      onRenewQuote: _ctx.createQuote,
      onPaid: _ctx.paid
    }, null, 8, ["quote", "onClearQuote", "onRenewQuote", "onPaid"])
  ], 64))
}